import React, { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; // 🔥 ADD THIS IMPORT
import { AuthContext } from '../AuthContext';
import Hero from './Hero';
import Services from './Services';
import WhyChoose from './WhyChoose';
import Identity from './Identity';
import GetStarted from './GetStarted';

const Landing = () => {
  const { isAuthenticated, ensName, address } = useContext(AuthContext);
  const [renderKey, setRenderKey] = useState(0);

  // 🔥 CRITICAL FIX: Force re-render when auth state changes
  useEffect(() => {
    console.log('🎯 Landing component detecting auth change:', {
      isAuthenticated,
      ensName,
      address
    });
    setRenderKey(prev => prev + 1);
  }, [isAuthenticated, ensName, address]);

  // Authenticated View - "Inside the Bank"
  if (isAuthenticated) {
    console.log('🔓 RENDERED: Authenticated Landing Page for:', ensName || address);
    return (
      <div key={renderKey}>
        <Helmet>
          <title>BankSystem - Your Banking Dashboard</title>
          <meta name="description" content="Access your global banking services - Payments, Cash, Forex, Broker, Markets, and more" />
        </Helmet>

        <section className="services">
          <div className="container">
            {/* Simple, lean header */}
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <h1>BankSystem</h1>
              <p style={{ color: 'var(--gold)', fontSize: '16px', margin: '10px 0' }}>
                {ensName || `${address?.substring(0, 8)}...`} is connected
              </p>
              <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
                Your global banking dashboard
              </p>
            </div>

            {/* Banking services grid - FIXED: Changed <a> to <Link> */}
            <div className="service-cards">
              <Link to="/web3pay" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
              >
                <h3>Payments</h3>
                <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3Pay.eth</p>
                <p>Daily-use stablecoin wallet for balances and transfers. QR code-based payments for goods.</p>
              </Link>

              <Link to="/web3cash" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
              >
                <h3>Cash</h3>
                <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3Cash.eth</p>
                <p>ENS-gated platform where decentralized lending and savings empower your financial future.</p>
              </Link>

              <Link to="/web3fx" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
              >
                <h3>Forex</h3>
                <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3FX.eth</p>
                <p>Currency Exchange, Secure swaps with competitive fees, Swap Stablecoins World Wide.</p>
              </Link>

              <Link to="/web3broker" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
              >
                <h3>Broker</h3>
                <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3Broker.eth</p>
                <p>Advanced Tokenized Stock Trading Platform, With Grok xAI as your guide.</p>
              </Link>

              <Link to="/web3markets" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
              >
                <h3>Markets</h3>
                <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3Markets.eth</p>
                <p>RWA Marketplace, Tokenized Real World Assets, World Wide, 24/7 Markets.</p>
              </Link>

              <Link to="/moneytalks" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
              >
                <h3>MoneyTalks</h3>
                <p className="eth-label" style={{ color: 'var(--gold)' }}>Community</p>
                <p>Exchange views on finance, DeFi, RWAs. Join our vibrant financial community.</p>
              </Link>

              <Link to="/safeguard" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
              >
                <h3>SafeGuard</h3>
                <p className="eth-label" style={{ color: 'var(--gold)' }}>OmniLock.eth</p>
                <p>Multi-signature time-lock escrow for maximum fund protection and security.</p>
              </Link>

              <Link to="/dbank" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
              >
                <h3>$DBANK Shares</h3>
                <p className="eth-label" style={{ color: 'var(--gold)' }}>BankSystem.eth</p>
                <p>Bank ownership shares with real dividend distribution and transparent equity structure.</p>
              </Link>
            </div>
          </div>
        </section>
      </div>
    );
  }

  // Public View - "Outside the Bank"
  console.log('🔒 RENDERED: Public Landing Page - Not authenticated');
  return (
    <div key={renderKey}>
      <Helmet>
        <title>BankSystem Rocks DeFi: Cut Costs, xAI Power, Freedom for Every Wallet!</title>
        <meta name="description" content="Fees that won't sting, AI-driven bank & finance forum – for everyone. Quick tease: $DBANK shares." />
        <meta property="og:title" content="BankSystem Rocks DeFi: Cut Costs, xAI Power, Freedom for Every Wallet!" />
        <meta property="og:description" content="Fees that won't sting, xAI-driven bank & finnce forum – for everyone. Quick tease: $DBANK shares." />
        <meta property="og:image" content="https://banksystem.co/home-preview.jpg" />
        <meta property="og:url" content="https://banksystem.co/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="BankSystem Rocks DeFi: Cut Costs, xAI Power, Freedom for Every Wallet!" />
        <meta name="twitter:description" content="Fees that won't sting, xAI-driven bank & finance forum – for everyone. Quick tease: $DBANK shares" />
        <meta name="twitter:image" content="https://banksystem.co/home-preview.jpg" />
      </Helmet>
      <Hero />
      <Services />
      {/* Subheadline (Sentence 2) in Gold color - Added as centered paragraph */}
      <p style={{ textAlign: 'center', color: '#FFD700', fontSize: '1.2rem', margin: '2rem 0', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto' }}>
        Fees that won't sting, AI-driven bank & finance forum – for everyone.
      </p>
      <Identity />
      <WhyChoose />
      <GetStarted />
    </div>
  );
};

export default Landing;
